import Billing from '../views/Billing';
import BillingIndex from '../views/billing/Index';
import BillingSuccess from '../views/billing/Success';

export const BILLING_ROUTES = {
  path: '/billing',
  component: Billing,
  meta: { title: 'Billing' },
  children: [
    {
      path: '',
      name: 'billing',
      component: BillingIndex,
      meta: { title: 'Billing' }
    },
    {
      path: 'success',
      name: 'billing-success',
      component: BillingSuccess,
      meta: { title: 'Billing' }
    }
  ]
};
